import resourceConfig from "../config";

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'Report |||| Reports',
            title: 'Quantity of Unused Marking Codes by GTIN',
            openAction: 'Open',
            executeAction: 'Generate',
            successMessage: 'File generation in progress. Find the file in the "Export files" journal',
            errorMessage: 'Error while starting report generation',
            fields: {
                status: 'Status',
                emissionType: 'Emission type',
            },
            status: {
                APPLIED: 'APPLIED',
                EMITTED: 'EMITTED',
            },
        }
    }
};